import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { getLibraryCategories, updateLibraryCategoryStatus, deleteLibraryCategory } from "./libraryServices/libraryManagement";
import { useGlobalState } from "../../../services/hostelConst";
import AddLibraryCategoryForm from "./library-forms/add-book-category-form";

const LibraryBookCategoryTable = () => {
  const { toggleHostelMenu } = useGlobalState();
  var { id } = useParams();
  console.log("the id here in the library book category table", id);
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    modalState,
    openModal,
  } = useGlobalState();

  useEffect(() => {
    openModal({ ...modalState, libraryId: id });
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
      };
    });

    toggleHostelMenu(false);

    return () => {};
  }, []);

  return (
    <MasterTable
      getTableData={getLibraryCategories}
      tab1={"Library"}
      tab2={"Categories"}
      updateStatus={updateLibraryCategoryStatus}
      libraryId={id}
      AddForm={AddLibraryCategoryForm}
      deleteRow={deleteLibraryCategory}
      actions={{
        status:true,
        edit: true,
        delete: true,
      }}
    />
  );
};
export default LibraryBookCategoryTable;
